export const HABILITADO = '1'
export const INHABILITADO = '2'

export const __dictionary = {
  [HABILITADO]: {
    id: HABILITADO,
    nombre: 'HABILITADO'
  },
  [INHABILITADO]: {
    id: INHABILITADO,
    nombre: 'INHABILITADO'
  }
}

export const __array = [__dictionary[HABILITADO], __dictionary[INHABILITADO]]
